import { Alert, Button, Card, Col, Form, message, Row, Space, TreeSelect, Typography } from 'antd'
import { useMyContext } from 'Context/MyContextProvider';
import React, { useEffect, useState } from 'react'
import { useTemplates } from 'hooks/api';
import TemplateComponent from '../../Campaign/TemplateComponent';
import { HandleTemplateChange } from '../../CustomUtils.js/TemplateUtils';
import NewMobilePreview from '../../Campaign/newMobilePreview';
import SelectMediaModel from '../../Campaign/CampainComps/SelectMediaModel';
import apiClient from 'services/apiClient';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import {
    InfoCircleOutlined,
} from '@ant-design/icons';
import ProgressModal from '../../Campaign/CampainComps/ProgressModal';
import { conicColors } from '../../Campaign/CampainComps/OtherUtils';
const { Text, Paragraph } = Typography;

const MaintenanceConfig = (props) => {
    const { Permisson, buttonStyle, apiKey } = useMyContext();
    const { templates } = useTemplates();
    const [showMediaModel, setShowMediaModel] = useState(false);
    const [templateList, setTemplateList] = useState([]);
    // State management suggestions
    const [progress, setProgress] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const [defaultRes, setDefaultRes] = useState({
        requestType: 'template',
        applyTo: 'all',
        customMessage: null,
        template: {
            raw: {},
            name: null,
            variables: [],
            newMessage: null,
            templateCategory: 'UTILITY',
            mediaLink: null,
            templateInputs: [],
            dynamicValues: [],
            dynamicUrlButton: [],
            templateUrlInputs: [],
            templatePreview: []
        },
        templateName: null,
        sendBefore: '06:00',
        mediaType: null

    });

    const applyToTreeData = [
        {
            title: 'All',
            value: 'all',
            selectable: true,
        },
        {
            title: 'User',
            value: 'user',
            selectable: false,
            children: [
                { title: 'User - All', value: 'user_all' },
                { title: 'User - Including Chatbot User', value: 'user_including_chatbot' },
                { title: 'User - Excluding Chatbot User', value: 'user_excluding_chatbot' },
            ],
        },
        {
            title: 'Reseller',
            value: 'reseller',
            selectable: false,
            children: [
                { title: 'Reseller - All', value: 'reseller_all' },
                { title: 'Reseller - Including Chatbot User', value: 'reseller_including_chatbot' },
                { title: 'Reseller - Excluding Chatbot User', value: 'reseller_excluding_chatbot' },
            ],
        },
    ];


    const handleTemplate = (value) => {
        ResetState();
        HandleTemplateChange(
            value,
            handleChange('mediaLink'),
            handleChange('templateName'),
            handleChange('templateKey'),
            templates,
            handleChange('templateCategory'),
            null,
            handleChange('templatePreview'),
            handleChange('raw'),
            handleChange('templateInputs'),
            handleChange('templateUrlInputs'),
            setDynamicValues, // <-- use the dedicated setter
            setDynamicUrlButton, // <-- use the dedicated setter
            defaultRes.template?.dynamicValues);
    }

    const handleChange = (field) => (value) => {
        setDefaultRes(prev => ({
            ...prev,
            template: {
                ...prev.template,
                [field]: value
            }
        }));
    };

    const ResetState = () => {
        setDefaultRes(prev => ({
            ...prev,
            template: {
                ...prev.template,
                name: null,
                variables: [],
                mediaLink: null,
                templateInputs: [],
                templateUrlInputs: [],
                dynamicValues: [],           // <-- Reset dynamicValues
                dynamicUrlButton: []         // <-- Reset dynamicUrlButton
            }
        }));
    }


    const setDynamicValues = (valuesOrUpdater) => {
        setDefaultRes(prev => {
            // If it's a function (like prevValues => [...prevValues]), call it with current values
            const newValues = typeof valuesOrUpdater === 'function'
                ? valuesOrUpdater(prev.template.dynamicValues)
                : valuesOrUpdater;

            return {
                ...prev,
                template: {
                    ...prev.template,
                    dynamicValues: newValues
                }
            };
        });
    };

    const setDynamicUrlButton = (valuesOrUpdater) => {
        setDefaultRes(prev => {
            // If it's a function (like prevValues => [...prevValues]), call it with current values
            const newValues = typeof valuesOrUpdater === 'function'
                ? valuesOrUpdater(prev.template.dynamicUrlButton)
                : valuesOrUpdater;

            return {
                ...prev,
                template: {
                    ...prev.template,
                    dynamicUrlButton: newValues
                }
            };
        });
    };

    useEffect(() => {
        if (defaultRes?.template?.templateCategory) {
            setDefaultRes(prev => ({
                ...prev,
                template: {
                    ...prev.template,
                    templateName: '', // <-- reset templateName inside template object
                },
                templateUrlInputs: [],
            }));
            const filteredList = (templates || [])
                .filter(item =>
                    (!defaultRes?.template?.templateCategory || item.category === defaultRes?.template?.templateCategory))
                .filter(item => !item.components?.some(comp => comp.type === 'CAROUSEL')
                );

            setTemplateList(filteredList);
        }
    }, [defaultRes?.template?.templateCategory, templates]);


    const HandleUploadImage = async (path, name, id) => {
        if (path) {
            setDefaultRes(prev => ({
                ...prev,
                template: {
                    ...prev.template,
                    mediaLink: path,
                    mediaName: name
                }
            }));
            setShowMediaModel(false)
        }
    };

    const GenerateBaseUrl = (number) => {
        const baseUrl = `https://sndwb.smsforyou.biz/api/send-messages?apikey=${apiKey}&to=91${number}&type=T&tname=${defaultRes?.template?.templatePreview?.name}`;
        let params = '';

        if (defaultRes?.template?.mediaLink) {
            params += `&media_url=${defaultRes.template.mediaLink}`;
        }
        if (Array.isArray(defaultRes.template.dynamicValues) && defaultRes.template.dynamicValues.length > 0) {
            params += `&values=${defaultRes.template.dynamicValues.join(',')}`;
        }
        if (Array.isArray(defaultRes.template.dynamicUrlButton) && defaultRes.template.dynamicUrlButton.length > 0) {
            params += `&button_value=${defaultRes.template.dynamicUrlButton.join(',')}`;
        }
        return baseUrl + params;
    }
    const handleDefaultResSubmit = async () => {
        try {
            // Initialize progress state
            setLoading(true);
            setIsModalVisible(true);
            setProgress(0);

            const data = defaultRes?.applyTo;

            // Fetch mobile numbers
            const response = await apiClient.post(
                '/get-mobile-numbers',
                { option: data }
            );

            const numbers = response.data.numbers; // Uncomment when using real API

            if (numbers.length === 0) {
                setLoading(false);
                setIsModalVisible(false);
                // Show error message - no numbers found
                return;
            }

            const totalNumbers = numbers.length;
            let completedRequests = 0;
            let successCount = 0;
            let failureCount = 0;
            const results = [];

            // Process messages with progress tracking
            const sendPromises = numbers.map(async (num, index) => {
                try {
                    const url = GenerateBaseUrl(num);
                    const response = await apiClient.post(url);

                    // Increment completed requests
                    completedRequests++;
                    successCount++;

                    // Calculate and update progress
                    const progressPercentage = Math.round((completedRequests / totalNumbers) * 100);
                    setProgress(progressPercentage);

                    // Store result
                    results.push({
                        number: num,
                        status: 'success',
                        response: response.data,
                        timestamp: new Date().toISOString()
                    });

                    // Optional: Add delay between requests to avoid rate limiting
                    await new Promise(resolve => setTimeout(resolve, 100));

                    return { success: true, number: num, data: response.data };
                } catch (error) {
                    // Increment completed requests (including failures)
                    completedRequests++;
                    failureCount++;

                    // Calculate and update progress
                    const progressPercentage = Math.round((completedRequests / totalNumbers) * 100);
                    setProgress(progressPercentage);

                    // Store error result
                    results.push({
                        number: num,
                        status: 'error',
                        error: error.message,
                        timestamp: new Date().toISOString()
                    });

                    console.error(`Failed to send message to ${num}:`, error);
                    return { success: false, number: num, error: error.message };
                }
            });

            // Wait for all requests to complete
            await Promise.allSettled(sendPromises);

            // Final progress update
            setProgress(100);

            // Optional: Show completion summary
            console.log('Message sending completed:', {
                total: totalNumbers,
                successful: successCount,
                failed: failureCount,
                results: results
            });

            // Hide modal after a brief delay to show 100% completion
            setTimeout(() => {
                setLoading(false);
                setIsModalVisible(false);

                // Optional: Show success/failure summary notification
                if (successCount === totalNumbers) {
                    // All messages sent successfully
                    message.success(`All ${totalNumbers} messages sent successfully!`);
                } else if (successCount > 0) {
                    // Partial success
                    message.warning(`${successCount}/${totalNumbers} messages sent successfully. ${failureCount} failed.`);
                } else {
                    // All failed
                    message.error('Failed to send all messages. Please check your configuration.');
                }
            }, 1500);

        } catch (error) {
            console.error('Error in handleDefaultResSubmit:', error);
            setLoading(false);
            setIsModalVisible(false);
            setProgress(0);
            // Show error notification
            message.error('An error occurred while processing your request.');
        }
    };
    return (
        <>
            <Row gutter={ROW_GUTTER}>
                <SelectMediaModel
                    openMediaModel={showMediaModel}
                    handleCancelMediaModel={() => setShowMediaModel(false)}
                    HandleUploadImage={HandleUploadImage}
                    requestType={'template'}
                    handleCustomMedia={null}
                />
                <ProgressModal
                    progress={progress}
                    isModalVisible={isModalVisible}
                    loading={loading}
                    conicColors={conicColors}
                />

                <Col span="12">
                    <Row>
                        <Col span={24}>
                            <Card title={'Maintenance Intimation'}>
                                <Form
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 24 }}
                                    layout="horizontal"
                                >
                                    <Form.Item
                                        label="Send To"
                                        name="applyTo"
                                        initialValue={defaultRes.applyTo || 'user_all'}
                                    >
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            treeData={applyToTreeData}
                                            placeholder="Please select"
                                            treeDefaultExpandAll
                                            value={defaultRes.applyTo || 'user_all'}
                                            onChange={(value) => {
                                                setDefaultRes(prev => ({
                                                    ...prev,
                                                    applyTo: value
                                                }));
                                            }}
                                        />
                                    </Form.Item>

                                    {defaultRes.requestType === 'template' &&
                                        <TemplateComponent
                                            templateCategory={defaultRes.template.templateCategory}
                                            setTemplateCategory={(value) => setDefaultRes(prev => ({
                                                ...prev,
                                                template: {
                                                    ...prev.template,
                                                    templateCategory: value
                                                }
                                            }))}
                                            templateName={defaultRes.template.templateName}
                                            templateList={templateList}
                                            HandleTemplate={handleTemplate}
                                            template={defaultRes.template.raw}
                                            mediaType={'Media'}
                                            showMediaModel={setShowMediaModel}
                                            mediaLink={defaultRes.template.mediaLink}
                                            buttonStyle={buttonStyle}
                                            mediaName={defaultRes.template.mediaName}
                                            setMediaLink={(value) => setDefaultRes(prev => ({
                                                ...prev,
                                                template: {
                                                    ...prev.template,
                                                    mediaLink: value
                                                }
                                            }))}
                                            templateInputs={defaultRes.template.templateInputs}
                                            templateUrlInputs={defaultRes.template.templateUrlInputs}
                                            loading={null}
                                            Permisson={Permisson}
                                        />
                                    }
                                    <Form.Item className='float-right'>
                                        <Button className='mt-3 px-3' type="primary" onClick={() => handleDefaultResSubmit()}>Submit</Button>
                                    </Form.Item>
                                </Form>
                            </Card>
                        </Col>
                        <Col span="24">
                            {/* Guidance Info: */}
                            <Card
                                title={
                                    <Space>
                                        <InfoCircleOutlined style={{ color: '#faad14' }} />
                                        <Text strong style={{ color: '#2c3e50' }}>Guidance</Text>
                                    </Space>
                                }
                            >
                                <Space direction="vertical" size="middle" className="w-100">
                                    <div>
                                        <Text strong style={{ color: '#1890ff' }}>Send To:</Text>
                                        <Paragraph style={{ margin: '4px 0', fontSize: '13px' }}>
                                            Use the TreeSelect to choose recipients. Options include All users,
                                            specific User groups, or Reseller groups. Expand the tree to see more options.
                                        </Paragraph>
                                    </div>

                                    <div>
                                        <Text strong style={{ color: '#52c41a' }}>Template:</Text>
                                        <Paragraph style={{ margin: '4px 0', fontSize: '13px' }}>
                                            Select a message template using the dropdown. You can preview
                                            and customize the template before sending.
                                        </Paragraph>
                                    </div>

                                    <div>
                                        <Text strong style={{ color: '#fa8c16' }}>Media:</Text>
                                        <Paragraph style={{ margin: '4px 0', fontSize: '13px' }}>
                                            (Optional) Attach an image or media file to your message
                                            using the media selector.
                                        </Paragraph>
                                    </div>

                                    <div>
                                        <Text strong style={{ color: '#eb2f96' }}>Send Message Before:</Text>
                                        <Paragraph style={{ margin: '4px 0', fontSize: '13px' }}>
                                            Choose how long before the maintenance event the message
                                            should be sent.
                                        </Paragraph>
                                    </div>
                                </Space>

                                <Alert
                                    message="Tip: Double-check your selections before submitting"
                                    description="For further help, contact your system administrator."
                                    type="warning"
                                    showIcon
                                    style={{ marginTop: '16px' }}
                                />
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col span="7">
                    <Card title="Template Preview">
                        <NewMobilePreview
                            requestType={defaultRes.requestType}
                            customMessage={defaultRes.customMessage}
                            template={defaultRes.template.raw}
                            mediaLink={defaultRes.template.mediaLink}
                            newMessage={defaultRes.template.newMessage}
                        />
                    </Card>
                </Col>
            </Row>
        </>

    )
}

export default MaintenanceConfig
